import { useTranslation } from "react-i18next"
import { Link, NavLink, useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import Button, { buttonStyle } from "~/components/Button"
import FormFooter from "~/components/FormFooter"
import { preferredImageUrlState } from "~/containers/LegacyDesigner/state/imageElements"
import type { IPart } from "~/containers/Proposal/Setup/Form/setup-steps-types"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { USES_ADAPTIVE_DESIGNER } from "~/utils/os"

const DesignPreview = styled(NavLink)<{ image: string }>`
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  flex-shrink: 1;
  position: relative;
  transition: all 0.3s ease-in-out;
  label {
    display: block;
    position: absolute;
    left: 10px;
    bottom: 10px;
    background: var(--cyan-3);
    color: white;
    text-decoration: none;
    padding: 10px;
    cursor: pointer;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
`
const Preview = styled(DesignPreview)`
  width: 100%;
  height: 100%;
  border: 1px solid var(--grey-border);
  border-radius: 6px;
  overflow: hidden;
  label {
    display: none;
  }
  :hover {
    transform: scale(1.02);
  }
`

const DesignLinkButton = styled.button<{ disabled?: boolean }>`
  ${buttonStyle}
  text-decoration: none;
  user-select: none;
  color: var(--white);
  background: var(--banner-blue);
  overflow: hidden;
  padding-left: 20px;
  padding-right: 20px;
  text-decoration: none;
  user-select: none;
  opacity: ${(props) => (props.disabled === true ? 0.5 : 1)};
`

const SystemDesign: IPart[`form`] = () => {
  const { t } = useTranslation()
  const proposal = useProposalContext()
  const designLink = `/proposal/${proposal.local.slug}/design${
    USES_ADAPTIVE_DESIGNER ? `-next` : ``
  }`
  const imageUrl = useRecoilValue(preferredImageUrlState)
  const navigate = useNavigate()

  return (
    <>
      <section>
        <Container>
          <Preview image={imageUrl} to={designLink} id="design-preview">
            <label htmlFor="design-preview"></label>
          </Preview>
        </Container>
      </section>
      <FormFooter
        style={{
          alignItems: `center`,
        }}
      >
        <Button
          onClick={() =>
            navigate(`/proposal/${proposal.local.slug}/setup/system-placement`)
          }
        >
          {t(`cancel`)}
        </Button>
        <Link to={designLink}>
          <DesignLinkButton>{t(`design`)}</DesignLinkButton>
        </Link>
      </FormFooter>
    </>
  )
}

export default SystemDesign
